// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_404-module--wrapper--1ujKC"};